import i18n from "@/libs/i18n";
export default [
  {
    title: i18n.t('menu.managementFood'),
    icon: 'bx bx-dish',
    children: [
      {
        title: i18n.t('menu.foodItems'),
        route: { name: 'food' },
        resource: 'FoodManager',
        action: 'show',
      },
      {
        title: i18n.t('menu.foodList'),
        route: { name: 'foodlist' },
        resource: 'FoodListManager',
        action: 'show',
      },
      {
        title: i18n.t('menu.indicators'),
        route: { name: 'foodindicator' },
        resource: 'FoodIndicatorManager',
        action: 'show',
      },
      {
        title: 'وعده ها',
        route: { name: 'foodmeal' },
        resource: 'FoodMealManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'foodcategory' },
        resource: 'FoodCategoryManager',
        action: 'show',
      },
      {
        title: ' واحدها',
        route: { name: 'foodunit' },
        resource: 'FoodUnitManager',
        action: 'show',
      },
      {
        title: 'نظرهای غذا',
        route: { name: 'foodcomment' },
        resource: 'FoodCommentManager',
        action: 'show',
      },
      {
        title: 'غذاهای پیشنهادی',
        route: { name: 'foodsuggestion' },
        resource: 'FoodSuggestionManager',
        action: 'show',
      },
      {
        title: 'دستور پخت ها',
        route: { name: 'foodrecipes' },
        resource: 'FoodRecipesManager',
        action: 'show',
      },
      {
        title: 'نظرهای دستور پخت',
        route: { name: 'foodrecipescomment' },
        resource: 'FoodRecipesCommentManager',
        action: 'show',
      },
    ],
  },
]
